export class UpdateShouldFullBackupResourceRequest {
    'shouldRunFullBackup';
    'shouldRunCoalesce';
    'shouldRunNonCdcBackup';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "shouldRunFullBackup",
            "baseName": "shouldRunFullBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shouldRunCoalesce",
            "baseName": "shouldRunCoalesce",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shouldRunNonCdcBackup",
            "baseName": "shouldRunNonCdcBackup",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateShouldFullBackupResourceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
